import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { ttpOrganizationExcerptsUrl } from 'SharedDir/backend/endpoints/ttp-excerpts';
import { ExcerptStatus } from 'SharedDir/constants/ttp';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { New, WithRelations } from 'SharedDir/declarations/shared';
import { TTPRegistries } from 'SharedDir/declarations/ttp-registries';

export default class OrganizationTtpExcerptApiClass extends SimpleApi<
  WithRelations<TTPRegistries.OrganizationExcerpt>,
  New<TTPRegistries.OrganizationExcerpt>
> {
  constructor() {
    super(ttpOrganizationExcerptsUrl);
  }

  async changeStatus(id: number, status: ExcerptStatus) {
    const { data } = (await http({
      url: `${this.url}/${id}/change-status`,
      method: 'PUT',
      data: { status },
    })) as AxiosResponse<StatusResponse>;
    return data;
  }

  /**
   * Получение количественных показателей по статусам.
   */
  async getStatistic(
    params: TTPRegistries.OrganizationTtpExcerptStatisticQueryParams
  ): Promise<TTPRegistries.TtpExcerptStatisticData> {
    const { data } = (await http({
      url: `${this.url}/statistic`,
      method: 'GET',
      params,
    })) as AxiosResponse<TTPRegistries.TtpExcerptStatisticData>;

    return data;
  }
}
